import React, { useMemo } from 'react';
import { Divider, Paper, useTheme } from "@mui/material";
import { PALETTE_PANE_ID, PalettePane } from './PalettePane';
import { BRUSH_SIZE_SLIDER_ID, BrushSizeSlider } from './BrushSizePane';
import { COLOR_BORDER_PRIMARY } from '../../../../core-ui/theme';
const interleave = (arr, divider) => [].concat(...arr.map(n => [n, divider])).slice(0, -1);
export const ToolOptionsPane = ({ tool, brushSizeSliderProps, easelPaneProps }) => {
    const theme = useTheme();
    const elements = useMemo(() => interleave([
        Boolean(tool.usesToolOptions?.[PALETTE_PANE_ID]) && React.createElement(PalettePane, { ...easelPaneProps }),
        Boolean(tool.usesToolOptions?.[BRUSH_SIZE_SLIDER_ID]) && React.createElement(BrushSizeSlider, { ...brushSizeSliderProps }),
    ].filter(e => Boolean(e)), React.createElement(Divider, { sx: { marginTop: '0.5em', marginBottom: '0.5em' } })), [tool]);
    return (elements.length)
        ? (React.createElement(Paper, { sx: {
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${COLOR_BORDER_PRIMARY}`,
            } }, elements)) : null;
};
//# sourceMappingURL=ToolOptionsPane.js.map